module.exports = __webpack_public_path__ + "static/media/06.5174b071.png";